<div *ngIf="messages$ | async as messages" class="udex-grid udex-mx-auto">
  <div @fadeInOut class="global-message global-message-success udex-mt-32" *ngFor="
      let confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; let i = index
    ">
    <udex-message-strip design="Positive" status-type="Icon" hide-close-button>
      <span class="body--s">{{ confMsg | cxTranslate }}</span>
    </udex-message-strip>
  </div>
  <div @fadeInOut class="global-message global-message-info udex-mt-32" *ngFor="
      let infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = index
    ">
    <udex-message-strip design="Information" status-type="Icon" hide-close-button>
      <span class="body--s">{{ infoMsg | cxTranslate }}</span>
    </udex-message-strip>
  </div>
  <div @fadeInOut class="global-message global-message-warning udex-mt-32" *ngFor="
      let infoMsg of messages[messageType.MSG_TYPE_WARNING];
      let i = index
    ">
    <udex-message-strip design="Warning" status-type="Icon" hide-close-button>
      <span class="body--s">{{ infoMsg | cxTranslate }}</span>
    </udex-message-strip>
  </div>
  <div @fadeInOut class="global-message global-message-danger udex-mt-32" *ngFor="
      let errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = index
    ">
    <udex-message-strip design="Negative" status-type="Icon" hide-close-button>
      <span class="body--s">{{ errorMsg | cxTranslate }}</span> 
    </udex-message-strip>
  </div>
</div>
